import { styled } from "../../../styled-components";

export const PlaceholderWrapper = styled.div<{ fitToContent: boolean }>`
    display: flex;
    position: relative;

    height: ${p => (p.fitToContent ? "300px" : "100%")};
    min-height: 76px;

    justify-content: center;
    align-items: center;

    background-color: ${p => p.theme.skeletonColor};
`;

export const ImageCarouselStyle = styled.div`
    position: relative;
    overflow: hidden;
    flex-shrink: 0;

    &.single-emoji .floating-overlay-text {
        color: ${p => p.theme.fgColorDark};
    }

    &.inset {
        margin: 0 ${p => p.theme.pageMarginMedium}px;
    }

    &.interactive {
        cursor: pointer;
    }

    .carousel-overlay {
        color: white;
    }

    @keyframes carousel-spin {
        from {
            transform: rotate(0);
        }
        to {
            transform: rotate(360deg);
        }
    }

    & div.upload-container {
        width: 100%;
        height: 100%;
        display: flex;

        justify-content: center;
        align-items: center;
    }

    .carousel-upload-button {
        width: 44px;
        height: 44px;
        border-radius: 1000px;

        color: white;

        background-color: rgba(0, 0, 0, 0.24);

        display: flex;
        justify-content: center;
        align-items: center;
        > input {
            position: absolute;
            width: 0;
            height: 0;
        }
    }
`;

export const ImageCarouselProgressBar = styled.div<{ progress: number }>`
    position: absolute;
    bottom: 0;
    left: 0;

    width: ${p => p.progress}%;
    height: 3px;

    background-color: ${p => p.theme.primaryAccentColor};
    z-index: 50;
`;

export const StreamlineCamera = ({ fillColor }: { fillColor?: string }) => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M12 0C5.373 0 0 5.373 0 12C0 18.627 5.373 24 12 24C18.627 24 24 18.627 24 12C23.993 5.376 18.624 0.007 12 0ZM17.5 16.5H6.5C5.395 16.5 4.5 15.605 4.5 14.5V9.5C4.5 8.395 5.395 7.5 6.5 7.5H8C8.184 7.483 8.358 7.411 8.5 7.293L9.793 6C10.122 5.694 10.551 5.516 11 5.5H13C13.449 5.516 13.878 5.694 14.207 6L15.5 7.293C15.642 7.411 15.816 7.483 16 7.5H17.5C18.605 7.5 19.5 8.395 19.5 9.5V14.5C19.5 15.605 18.605 16.5 17.5 16.5ZM12 9C13.657 9 15 10.343 15 12C15 13.657 13.657 15 12 15C10.343 15 9 13.657 9 12C9 10.343 10.343 9 12 9Z"
            fill={fillColor ?? "white"}
        />
    </svg>
);
